import { Injectable, signal } from '@angular/core';
import { UserExtraLite } from '../auth';
import { Language } from '../language';

const PLACEHOLDER_USER_SEED: ReadonlyArray<
  readonly [fname: string, lname: string, picture: string, slug: string]
> = [
  ['Kimi', 'Sagato', 'https://randomuser.me/api/portraits/men/98.jpg', 'kimi-sagato'],
  ['June', 'Bird', 'https://randomuser.me/api/portraits/women/44.jpg', 'june-bird'],
  ['Mario', 'Fratelli', 'https://randomuser.me/api/portraits/men/20.jpg', 'mario-fratelli'],
  ['Sveta', 'Dolinski', 'https://randomuser.me/api/portraits/women/23.jpg', 'sveta-dolinski'],
  ['Mawar', 'Wahyuni', 'https://randomuser.me/api/portraits/women/27.jpg', 'mawar-wahyuni'],
];

const PLACEHOLDER_LANGUAGES: Language[] = [
  {
    id: 41,
    name: 'English',
    iso: 'en',
    flag: {
      hash: 'Vy9orn',
      emoji: '\ud83c\uddec\ud83c\udde7',
    },
  },
  {
    id: 53,
    name: 'Greek',
    iso: 'el',
    flag: {
      hash: 'KMJbZ0',
      emoji: '🇬🇷',
    },
  },
  {
    id: 48,
    name: 'French',
    iso: 'fr',
    flag: {
      hash: 'gy4FJr',
      emoji: '\ud83c\uddeb\ud83c\uddf7',
    },
  },
];

@Injectable({
  providedIn: 'root',
})
export class PlaceholderService {
  private readonly placeholderUsersState = signal<UserExtraLite[]>(
    PLACEHOLDER_USER_SEED.map(([fname, lname, picture, slug]) => ({
      id: 0,
      fname,
      lname,
      pre_honorific: '',
      post_honorific: '',
      name_full_honorific: `${fname} ${lname}`,
      avatar_disk: 'external',
      avatar_path: picture,
      slug,
    }))
  );

  private readonly languagesState = signal<Language[]>(PLACEHOLDER_LANGUAGES);

  public readonly placeholderUsers = this.placeholderUsersState.asReadonly();
  public readonly languages = this.languagesState.asReadonly();

  constructor() {}

  makeAvatarFile() {
    return (
      'https://randomuser.me/api/portraits/' +
      (Math.random() > 0.5 ? 'wo' : '') +
      'men/' +
      Math.ceil(Math.random() * 95) +
      '.jpg'
    );
  }
  getUsers(count: number): UserExtraLite[] {
    const users = [...this.placeholderUsersState()];
    for (let i = users.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [users[i], users[j]] = [users[j], users[i]];
    }
    return users.slice(0, count);
  }
}
